import React from 'react';
import { IoArrowBackSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const Back = ({ back, spacebottom, dblock }) => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    return (
        <>
            <span className={`cursor-pointer ${spacebottom} ${dblock}`} onClick={goBack}>
                <IoArrowBackSharp /> <span>{back}</span>
            </span>
        </>
    );
};

export default Back;
